<template>
  <div class="app-layout">
    <slot></slot>
  </div>
</template>
